export default __webpack_public_path__ + "static/media/015-fence.12ae2aca.svg";